module.exports = __webpack_public_path__ + "static/img/dingzhi10.52b3a18.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dingzhi10.jpg
// module id = I+xE
// module chunks = 0